import StaffMemberCompensationSection from '@/components/StaffMemberCompensationSection';
import StaffMemberContractForm from '@/components/StaffMemberContractForm';
import StaffMemberJobSection from '@/components/StaffMemberJobSection';
import { StaffMember } from '@/types/api/staffMember';
import { onScrollToSmoothly } from '@/utils/global';
import * as Styles from './StaffMemberJob.styles';
import SectionBox from '../../components/SectionBox';

type Props = {
  staffMemberId: string;
  staffMember?: StaffMember;
  onUpdateStaffMember?: () => void;
};

const StaffMemberJob = ({
  staffMember,
  staffMemberId,
  onUpdateStaffMember,
}: Props): JSX.Element => {
  return (
    <Styles.PageGrid>
      <Styles.Sidebar
        sidebarMenus={[
          {
            label: 'Contract',
            id: 'sidebar-contract',
            onClick: () => onScrollToSmoothly('contract'),
          },
          {
            label: 'Job',
            id: 'sidebar-job',
            onClick: () => onScrollToSmoothly('job'),
          },
          {
            label: 'Compensation',
            id: 'sidebar-compensation',
            onClick: () => onScrollToSmoothly('compensation'),
          },
        ]}
      />

      <Styles.Content>
        <SectionBox title="Contract" id="contract" className="!tw-pb-[4px] !tw-static">
          <StaffMemberContractForm
            staffMemberId={staffMemberId}
            contract={staffMember?.contract || undefined}
            onUpdateStaffMember={onUpdateStaffMember}
          />
        </SectionBox>
        <StaffMemberJobSection id="job" staffMemberId={staffMemberId} />
        <StaffMemberCompensationSection id="compensation" staffMemberId={staffMemberId} />
      </Styles.Content>
    </Styles.PageGrid>
  );
};

export default StaffMemberJob;
